/*
 *
 * ImageFieldCreator
 *
 */

import React from 'react';
import createImageFieldContainer from './createImageFieldContainer';

class ImageFieldCreator extends React.PureComponent {
    render() {
        const ImageFieldContainer = createImageFieldContainer('file');
        return <ImageFieldContainer {...this.props} />;
    }
}

export default ImageFieldCreator;
